import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Renderer2, SecurityContext } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { format, isAfter, isBefore, isEqual, parseISO } from 'date-fns';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { FooldalService } from 'src/app/services/fooldal.service';
import { HtmlconvertService } from 'src/app/services/htmlconvert.service';
import { extractSources } from 'src/app/services/util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fbp',
  templateUrl: './fbp.component.html',
  styleUrls: ['./fbp.component.css']
})

export class FbpComponent {
  content: any[] = [];
  hallProducts: any[] = [];
  hallProductsMaps: any[] = [];
  baseUrl: string = environment.apiBaseUrl;
  isTextCondensed: boolean = false;
  isTextBackgroundGreen: boolean = false;
  showModal1: boolean = false;
  showModal2: boolean = false;
  modalTitle1: string = '';
  modalSessionTitle: string = '';
  modalTitle2: string = '';
  modalContent1: string = '';
  modalContent2: string = '';
  selectedProductId: string = '';
  selectedProductVariationId: string = '';
  todayDateVsHallDate: boolean = true;
  convertedDate!: Date|null;
  loggedInSelectedProductId: string = '';
  loggedInSelectedProductVariationId: string = '';
  loggedInConvertedDate!: Date|null;
  isLoggedIn: boolean = false;
  userUuid: string = '';
  productDatas: any = {};
  bookData: any = {};
  postDataProducts: any = {};
  bookForm!: FormGroup
  private hallSubscription: Subscription | undefined;
  purchasedUuids: any[] = [];

  constructor(private fooldalService: FooldalService, private datePipe: DatePipe, private authService: AuthService,
    private htmlconvertService: HtmlconvertService, private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef, private renderer: Renderer2, private router: Router) {
    this.bookForm = new FormGroup({
      email: new FormControl('')
    });
  }
  sessionTitle: string = '';
  sendBookForm() {
    if (this.bookForm.valid) {
      var email = this.bookForm.get('email')?.value
    }
    if(!this.convertedDate || this.convertedDate.toString().trim().length === 0) {
      this.convertedDate = null;
    }
    const bookData = {
      "data": {
        "type": "hallsession_appointment--default",
        "attributes": {
          "status": true,
          "field_email": email,
          "field_email_at": this.convertedDate
        },
        "relationships": {
          "field_product": {
            "data": {
              "type": "product--hallsession",
              "id": this.selectedProductId
            }
          },
          "field_product_variation": {
            "data": {
              "type": "product-variation--hallsession",
              "id": this.selectedProductVariationId
            }
          }
        }
      }
    }
    console.log(bookData);
    this.fooldalService.postHallBook(bookData).subscribe(book => {
        this.closeModal(1);
        const modal1 = document.getElementById('exampleModal1');
        if (modal1) {
          modal1.style.display = 'block';
          modal1.classList.add('show');
        }

        this.showModal1 = true;
        this.renderer.addClass(document.body, 'no-scroll');

        this.modalTitle1 = 'Előjegyzés';
        this.modalSessionTitle  = this.sessionTitle;
    })
  }

  extractVideoIdAndTime(url: string): { videoId: string | null, time: string | null } {
    const videoIdRegex = /[?&]v=([^&#]*)/i;
    const timeRegex = /[?&]t=([^&#]*)/i;

    const videoIdMatch = videoIdRegex.exec(url);
    const timeMatch = timeRegex.exec(url);

    const videoId = videoIdMatch ? videoIdMatch[1] : null;
    const time = timeMatch ? timeMatch[1] : null;

    return { videoId, time };
  }

  isLastItem(index: number): boolean {
    return index === this.hallProducts.length - 1;
  }

  openBookModalInLogged(productId: string, productVariationId: string, date: Date, sessionTitle: string) {
    this.loggedInSelectedProductId = productId;
    this.loggedInSelectedProductVariationId = productVariationId;
    this.loggedInConvertedDate = date;
    if(!this.loggedInConvertedDate || this.loggedInConvertedDate.toString().trim().length === 0) {
      this.loggedInConvertedDate = null;
    }


    const storedDataString = localStorage.getItem('login');

    if (storedDataString) {

      const storedDataObject = JSON.parse(storedDataString);
      var loggedUserName = storedDataObject.current_user.name
    }
    this.authService.getCurrentUser().subscribe(user => {
      const value = user.data[0];
              var loggedEmail = value.attributes.mail;
              this.userUuid = value.id;

              this.bookData = {
                "data": {
                  "type": "hallsession_appointment--default",
                  "attributes": {
                    "status": true,
                    "field_email": loggedEmail,
                    "field_email_at": this.loggedInConvertedDate
                  },
                  "relationships": {
                    "field_product": {
                      "data": {
                        "type": "product--hallsession",
                        "id": this.loggedInSelectedProductId
                      }
                    },
                    "field_product_variation": {
                      "data": {
                        "type": "product-variation--hallsession",
                        "id": this.loggedInSelectedProductVariationId
                      }
                    },
                    "uid": {
                      "data": {
                        "type": "user--user",
                        "id": this.userUuid
                      }
                    }
                  }
                }

              }
              this.fooldalService.postHallBook(this.bookData).subscribe(user => {
                this.fooldalService.getHallSessionBookings(this.userUuid).subscribe(bookings => {
                  this.bookedUuids = bookings.data.map((booking: any) => booking.relationships.field_product.data.id);
                });
              });

    });

    const modal1 = document.getElementById('exampleModal1');
    if (modal1) {
      modal1.style.display = 'block';
      modal1.classList.add('show');
    }

    this.showModal1 = true;
    this.renderer.addClass(document.body, 'no-scroll');

    this.modalTitle1 = 'Előjegyzés';
    this.modalSessionTitle  = sessionTitle;

  }

  openBookModal(productId: string, productVariationId: string, date: Date, title: string) {
    this.selectedProductId = productId;
    this.selectedProductVariationId = productVariationId;
    this.convertedDate = date;
    this.sessionTitle = title;


    const modal2 = document.getElementById('exampleModal2');

    if (modal2) {
      modal2.style.display = 'block';
      modal2.classList.add('show');
    }

    this.showModal2 = true; // Módosítás itt

    this.renderer.addClass(document.body, 'no-scroll');
    console.log(productVariationId);

    this.modalTitle1 = 'Facebook';
  }


  closeModal(modalNumber: number) {
    const modal1 = document.getElementById('exampleModal1');
    const modal2 = document.getElementById('exampleModal2');

    if (modal1 && modal2) {
      modal1.style.display = 'none';
      modal1.classList.remove('show');
      modal2.style.display = 'none';
      modal2.classList.remove('show');
    }

    this.showModal1 = false;
    this.showModal2 = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  isPurchased(uuid: string){
    return this.purchasedUuids.includes(uuid);
  }

  ngOnInit() {
    this.authService.checkSession().subscribe((isAuthenticated: boolean) => {
      this.isLoggedIn = isAuthenticated;
      if (this.isLoggedIn) {
        this.authService.getCurrentUserUUID().subscribe((uuid: string) => {
          this.userUuid = uuid;
          this.fooldalService.getHallSessionBookings(uuid).subscribe(bookings => {
            this.bookedUuids = bookings.data.map((booking: any) => booking.relationships.field_product.data.id);
          });
        });
      }
    });

    this.fooldalService.getOrders().subscribe((orders) => {
      this.purchasedUuids = orders.data.map((order: any) => order.order_items[0].purchased_entity.id);
    });

    this.fooldalService.getId().subscribe((i) => {
      for (const [key, value] of Object.entries(i)) {
        if (Array.isArray(value)) {
          for (const [k, v] of Object.entries(value)) {
            if (v.title === 'Foglalkozások teremben') {
              this.fooldalService.getFooldal(v.id).subscribe((page) => {
                for (const [key, value] of Object.entries(page)) {
                  for (var k in value.field_paragraphs) {

                    const obj = {
                      content: '' as SafeHtml, youtube_video: "", img_url: "", img_layout: "",
                      video_url: "", text_condensed: "" as SafeHtml, button_content: "" as SafeHtml,
                      text_highlighted_content: "" as SafeHtml, video: "", video_thumbnail: "",
                      img_alt:"", img_blue_alt: "", video_360: "", video_720: "", video_1080: "", video_2K: "",
                      alignmentSettings: {
                        isCenterText: false,
                        isJustifiedText: false,
                        isRightText: false,
                        isLeftText: false
                      },
                      textColorSettings: {
                        isPink: false,
                        isBlue: false,
                        isItalic: false
                      },
                      sources: Array()
                    }
                    if (value.field_paragraphs[k].type === 'paragraph--image_full') {
                      obj.img_url = this.baseUrl + value.field_paragraphs[k].field_image_full.field_media_image.uri.url;
                      obj.img_alt = value.field_paragraphs[k].field_image_full.field_media_image.meta.alt
                    } else if (value.field_paragraphs[k].type === 'paragraph--image_text_blue') {
                      obj.content = this.htmlconvertService.convertToHtml(value.field_paragraphs[k].field_content.value);
                      obj.img_url = this.baseUrl + value.field_paragraphs[k].field_image_inline.field_media_image.uri.url;
                      obj.img_blue_alt =  value.field_paragraphs[k].field_image_inline.field_media_image.meta.alt;
                      obj.img_layout = value.field_paragraphs[k].field_layout;
                    } else if (value.field_paragraphs[k].type === 'paragraph--text') {

                      const alignment = value.field_paragraphs[k].field_alignment;

                      obj.alignmentSettings = {
                        isCenterText: alignment === 'align-center',
                        isJustifiedText: alignment === 'align-justified',
                        isRightText: alignment === 'align-right',
                        isLeftText: alignment === 'align-left'
                      };

                      const textColor = value.field_paragraphs[k].field_format;
                      obj.textColorSettings = {
                        isPink: textColor === 'color-pink',
                        isBlue: textColor === 'color-blue',
                        isItalic: textColor === 'style-italic'

                      };
                      if (value.field_paragraphs[k].field_content !== undefined) {
                        const paragraph_value = this.htmlconvertService.convertToHtml(value.field_paragraphs[k].field_content.value);
                        obj.content = paragraph_value;
                      }
                    } else if (value.field_paragraphs[k].type === 'paragraph--video') {
                      //obj.video_url = this.baseUrl + value.field_paragraphs[k].field_video.field_media_video_file.uri.url;
                    } else if (value.field_paragraphs[k].type === 'paragraph--text_condensed') {
                      const paragraph_condensed = this.htmlconvertService.convertToHtml(value.field_paragraphs[k].field_content.value);
                      obj.text_condensed = paragraph_condensed;
                      if (obj.text_condensed) {
                        this.isTextCondensed = true;
                      } else {
                        this.isTextCondensed = false;
                      }
                    } else if (value.field_paragraphs[k].type === 'paragraph--button') {
                      const button_value = value.field_paragraphs[k].field_content.value;
                      const buttonValueAsText: string = this.sanitizer.sanitize(SecurityContext.HTML, button_value) || '';
                      const buttonContentWithoutPTags = buttonValueAsText.replace(/<\/?p[^>]*>/g, '');
                      const buttonContentTrimmed = buttonContentWithoutPTags.trim();
                      obj.button_content = this.sanitizer.bypassSecurityTrustHtml(buttonContentTrimmed);
                    } else if (value.field_paragraphs[k].type === 'paragraph--text_highlighted') {
                      const highlighted_value = this.htmlconvertService.convertToHtml(value.field_paragraphs[k].field_content.value);
                      obj.text_highlighted_content = highlighted_value;
                      if (obj.text_highlighted_content) {
                        this.isTextBackgroundGreen = true;
                      } else {
                        this.isTextBackgroundGreen = false;
                      }
                    } else if (value.field_paragraphs[k].type === 'paragraph--video') {
                      obj.video = this.baseUrl + value.field_paragraphs[k].field_video.field_media_video_file.uri.url
                      obj.video_thumbnail = this.baseUrl + value.field_paragraphs[k].field_video.field_thumbnail.field_media_image.uri.url;
                      obj.sources = extractSources(value.field_paragraphs[k].field_video, this.baseUrl);
                    } else if (value.field_paragraphs[k].type === 'paragraph--youtube_video') {
                      const videoId = this.extractVideoIdAndTime(value.field_paragraphs[k].field_youtube_video.field_media_oembed_video).videoId;
                      obj.youtube_video = "https://www.youtube.com/embed/" + videoId
                    }
                    this.content.push(obj);

                  }
                }
              });
            }
          }
        }
      }
    });

    this.fooldalService.getHallSessionProduct().subscribe(hall => {
      for (const [key, value] of Object.entries(hall)) {
        if (key === 'data') {
          for (let i in value) {
            if(!value[i].status) {
              continue;
            }

            const hallObj = {
              title: '',
              place: '',
              lat: 0,
              long: 0,
              date: '',
              summary: '' as SafeHtml,
              desc: '' as SafeHtml,
              max_member: '',
              price: '',
              product_id: '',
              var_id: '',
              var_type: '',
              convertedDate: '',
              registerData: '',
              is_booked: false,
              is_can_pay: false,
              todayDateVsHallDate: true,
              variations: [],
            }

            hallObj.title = value[i].title;
            hallObj.place = value[i].field_location.field_label;
            let rawDate = value[i].field_date;
            let formattedDate = rawDate ? this.datePipe.transform(rawDate, 'yyyy.MM.dd. – HH:mm') : '';
            hallObj.date = formattedDate || '';
            let rawDateR = value[i].field_registration_start;

            let formattedDateR = rawDateR ? this.datePipe.transform(rawDateR, 'yyyy.MM.dd. – HH:mm') : '';

            hallObj.registerData = formattedDateR || ''
            let converted = this.htmlconvertService.convertToHtml(value[i].body.summary);
            hallObj.summary = converted;
            let descConverted = this.htmlconvertService.convertToHtml(value[i].body.value);
            hallObj.desc = descConverted;

            if (value[i].variations.length !== undefined) {
              hallObj.max_member = value[i].variations[0].field_headcount.available_stock;
              hallObj.price = value[i].variations[0].price.formatted;

              hallObj.var_type = value[i].variations[0].type;
              hallObj.var_id = value[i].variations[0].id;

              if (value[i].variations && value[i].variations.length) {
                const variations = value[i].variations.map((variation: any) => {
                  if(!variation.status) {
                    return {status: variation.status};
                  }
                  const coord = variation.field_location?.field_address ?? '';
                  const coordSplit = coord.split(',');
                  const NumberLat = Number(coordSplit[0]);
                  const NumberLong = Number(coordSplit[1]);

                  // Format full datetime
                  const formattedDate = this.formatDate(variation.field_date);
                  const formattedDateR = this.formatDate(variation.field_registration_start);

                  // Extract only date part
                  const onlyDate = formattedDate ? formattedDate.split(' – ')[0] : '';
                  const regData = formattedDateR ? formattedDateR.split(' – ')[0] : '';

                  const convertedOnlyDate = onlyDate
                    ? format(this.parseDate(onlyDate), 'yyyy-MM-dd')
                    : '';

                  const convertedRegDate = regData
                    ? format(this.parseDate(regData), 'yyyy-MM-dd')
                    : '';

                  const convertOnlyDate = convertedOnlyDate
                    ? parseISO(convertedOnlyDate)
                    : undefined;

                  const convertTodayDate = parseISO(format(new Date(), 'yyyy-MM-dd'));

                  const convertRegDate = convertedRegDate
                    ? parseISO(convertedRegDate)
                    : undefined;

                  let is_can_pay = false;
                  let is_booked = false;

                  if (convertOnlyDate && !isBefore(convertOnlyDate, convertTodayDate)) {
                    if (
                      formattedDate &&
                      (isEqual(convertOnlyDate, convertTodayDate) ||
                        (convertRegDate && isBefore(convertRegDate, convertTodayDate))) &&
                      (+variation.field_headcount?.available_stock! > 0)
                    ) {
                      is_can_pay = true;
                    } else if (
                      !formattedDate ||
                      isAfter(convertOnlyDate, convertTodayDate) ||
                      +variation.field_headcount?.available_stock! <= 0
                    ) {
                      is_booked = true;
                    }
                  }

                  return {
                    title: variation.field_variation_name,
                    max_member: variation.field_headcount?.available_stock ?? null,
                    price: variation.price?.formatted ?? null,
                    var_type: variation.type,
                    var_id: variation.id,

                    place: variation.field_location?.field_label ?? '',
                    date: formattedDate,
                    registerData: convertedRegDate,
                    summary: this.htmlconvertService.convertToHtml(
                      variation.field_variation_description?.processed ?? ''
                    ) as SafeHtml,

                    lat: NumberLat,
                    long: NumberLong,
                    is_can_pay,
                    is_booked,
                    status: variation.status
                  };

                });

                hallObj.variations = variations.filter((v:any) => v.status);

              }

            }
            hallObj.product_id = value[i].id;
            let coord = value[i].field_location.field_address;
            const coordSplit = coord.split(',');
            const NumberLat = Number(coordSplit[0]);
            const NumberLong = Number(coordSplit[1]);
            const todayDate: string = format(new Date(), 'yyyy.MM.dd');
            let convertOnlyDate = undefined;
            if(formattedDate) {
              const onlyDate: string = formattedDate ? formattedDate.split(' – ')[0] : '';
              const convertedOnlyDate = format(this.parseDate(onlyDate), 'yyyy-MM-dd');
              hallObj.convertedDate = convertedOnlyDate;
              convertOnlyDate = parseISO(convertedOnlyDate);
            }
            const regData: string = formattedDateR ? formattedDateR.split(' – ')[0] : '';

            const convertedTodayDate = format(new Date(), 'yyyy-MM-dd');

            const convertedRegDate = regData != '' ? format(this.parseDate(regData), 'yyyy-MM-dd') : '';


            hallObj.registerData = convertedRegDate;
            const convertTodayDate = parseISO(convertedTodayDate);

            const convertRegDate = convertedRegDate != '' ? parseISO(convertedRegDate): '';




            // Kiegészítés: Ne pusholja bele a tömbbe, ha a dátum a mai dátum előtt van
            if (true || !isBefore(convertOnlyDate, convertTodayDate)) {
              if ( formattedDate && (isEqual(convertOnlyDate!, convertTodayDate) || (convertRegDate instanceof Date && isBefore(convertRegDate, convertTodayDate))) && (+hallObj.max_member > 0)) {
                hallObj.is_can_pay = true;
              } else if (!formattedDate || isAfter(convertOnlyDate!, convertTodayDate) || +hallObj.max_member <= 0) {
                hallObj.is_booked = true;
              }
              hallObj.lat = NumberLat;
              hallObj.long = NumberLong;
              this.hallProducts.push(hallObj);
              localStorage.setItem('hall', JSON.stringify(this.hallProducts));
              this.cdr.detectChanges();
            }
          }
        }
      }
    });

    if(this.isLoggedIn) {
      this.fooldalService.getHallSessionBookings(localStorage.getItem('userUuid')!).subscribe(bookings => {
        const currentUsersBookings = bookings.data.filter((booking: any) => booking.relationships.uid.data.id === localStorage.getItem('userUuid'));
        this.bookedUuids = currentUsersBookings.map((booking: any) => booking.relationships.field_product.data.id);
      });
    }
    console.log(this.hallProducts);

  }

  private formatDate(date: string | null | undefined): string {
    return date
      ? this.datePipe.transform(date, 'yyyy.MM.dd. – HH:mm') || ''
      : '';
  }


  bookedUuids: any[] = [];

  alreadyBooked(uuid:string) : boolean {
    return this.bookedUuids.includes(uuid);
  }

  private parseDate(dateString: string): Date {
    // Remove the trailing period if it exists
    if (dateString.endsWith('.')) {
        dateString = dateString.slice(0, -1);
    }

    // Split the string by the period character
    const parts = dateString.split('.');

    // Extract year, month, and day from the parts
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is zero-based in JavaScript Date
    const day = parseInt(parts[2], 10);

    // Create a new Date object
    const date = new Date(year, month, day);

    return date;
}

  addCart(type: any, id: any) {
    if(!this.isLoggedIn) {
      this.router.navigate(['/signin'], { queryParams: { from: 'foglalkozasok-teremben' } });
      return;
    }
    localStorage.setItem('teremben', 'true');
    this.postDataProducts = {
      data: [
        {
          type: type,
          id: id,
          meta: {
            quantity: 1,
            combine: true,
          },
        },
      ],
    };
    const objProf = {
      name: '',
    };
    const objBilling = {
      country_code: '',
      locality: '',
      postal_code: '',
      address_line1: '',
      address_line2: '',
      given_name: '',
      family_name: '',
    };

    this.fooldalService.addItemToCart(this.postDataProducts).subscribe((p:any) => {
      const value = p.data[0];
            const obj = {
              title: '',
              price: '',
            };
            obj.title = value.attributes.title;
            obj.price = value.attributes.total_price.formatted;
            localStorage.setItem('product', JSON.stringify(obj));

            this.authService.getCurrentUser().subscribe((user) => {
              const vv = user.data[0];
                    objProf.name = vv.attributes.name;

                    if (this.isLoggedIn) {
                      var loginData = JSON.parse(localStorage.getItem('login') || '');

                      if (loginData && loginData.current_user && loginData.current_user.name) {
                        var name = loginData.current_user.name;
                      }
                    }

                    if (name === objProf.name) {
                      var userId = vv.id;
                      this.fooldalService.getProfileCustomer().subscribe((profile: any) => {
                        const v = profile.data[0];
                        objBilling.country_code = v.attributes.address.country_code;
                        objBilling.locality = v.attributes.address.locality;
                        objBilling.postal_code = v.attributes.address.postal_code;
                        objBilling.address_line1 = v.attributes.address.address_line1;
                        objBilling.address_line2 = v.attributes.address.address_line2;
                        objBilling.given_name = v.attributes.address.given_name;
                        objBilling.family_name = v.attributes.address.family_name;
                        this.productDatas = {
                          "data": {
                            "type": value.relationships.order_id.data.type,
                            "id": value.relationships.order_id.data.id,
                            "attributes": {
                              "billing_information": {
                                "address": {
                                  "country_code": objBilling.country_code,
                                  "locality": objBilling.locality,
                                  "postal_code": objBilling.postal_code,
                                  "address_line1": objBilling.address_line1,
                                  "address_line2": objBilling.address_line2,
                                  "given_name": objBilling.given_name,
                                  "family_name": objBilling.family_name,
                                },
                                "tax_number": {
                                  "type": null,
                                  "value": null
                                }
                              }
                            },
                            "relationships": {
                              "uid": {
                                "data": {
                                  "type": "user--user",
                                  "id": userId
                                }
                              }
                            }
                          }
                        };
                        var orderId = value.relationships.order_id.data.id;
                        this.fooldalService.addProductWithCart(this.productDatas, orderId).subscribe((p) => {
                          for (const [keyP, valueP] of Object.entries(p)) {
                            if (keyP === 'data') {
                              for (let k in valueP) {
                                localStorage.setItem('productId', valueP.id.toString());
                              }
                            }
                          }
                          if (this.isLoggedIn) {
                            this.router.navigate(['/fizetes']);
                          } else {
                            this.router.navigate(['/signin'], { queryParams: { from: 'fbp' } });
                          }
                        });
                      });
                    } else {
                      var userId2 = localStorage.getItem('user_id');
                      if (userId2 !== null) {
                        var userIdIfNotLog = userId2.replace(/"/g, '');
                      } else {
                      }
                      this.fooldalService.getProfileCustomer().subscribe((profile) => {
                        for (const [k, v] of Object.entries(profile)) {
                          if (k === 'data') {
                            for (let j in v) {
                              if (userIdIfNotLog === v[j].relationships.uid.data.id) {
                                objBilling.country_code = v[j].attributes.address.country_code;
                                objBilling.locality = v[j].attributes.address.locality;
                                objBilling.postal_code = v[j].attributes.address.postal_code;
                                objBilling.address_line1 = v[j].attributes.address.address_line1;
                                objBilling.address_line2 = v[j].attributes.address.address_line2;
                                objBilling.given_name = v[j].attributes.address.given_name;
                                objBilling.family_name = v[j].attributes.address.family_name;
                              }
                            }
                          }
                        }
                        this.productDatas = {
                          "data": {
                            "type": value.relationships.order_id.data.type,
                            "id": value.relationships.order_id.data.id,
                            "attributes": {
                              "billing_information": {
                                "address": {
                                  "country_code": objBilling.country_code,
                                  "locality": objBilling.locality,
                                  "postal_code": objBilling.postal_code,
                                  "address_line1": objBilling.address_line1,
                                  "address_line2": objBilling.address_line2,
                                  "given_name": objBilling.given_name,
                                  "family_name": objBilling.family_name,
                                },
                                "tax_number": {
                                  "type": null,
                                  "value": null
                                }
                              }
                            },
                            "relationships": {
                              "uid": {
                                "data": {
                                  "type": "user--user",
                                  "id": userIdIfNotLog
                                }
                              }
                            }
                          }
                        };
                        var orderId = value.relationships.order_id.data.id;
                        this.fooldalService.addProductWithCart(this.productDatas, orderId).subscribe((p) => {
                          for (const [keyP, valueP] of Object.entries(p)) {
                            if (keyP === 'data') {
                              for (let k in valueP) {
                                localStorage.setItem('productId', valueP.id.toString());
                              }
                            }
                          }
                        });
                        if (this.isLoggedIn) {
                          this.router.navigate(['/fizetes']);
                        } else {
                          this.router.navigate(['/signin'], { queryParams: { from: 'fbp' } });
                        }
                      });
                    }
            });
    });
  }

  ngOnDestroy() {
    // Leiratkozás a hallSubscription-ról, hogy elkerüljük a memórialeakokat
    if (this.hallSubscription) {
      this.hallSubscription.unsubscribe();
    }
  }
}
